module.exports = __webpack_public_path__ + "images/modules/how-it-works/howitworks3.svg";


//////////////////
// WEBPACK FOOTER
// ./images/modules/how-it-works/howitworks3.svg
// module id = 74
// module chunks = 0